/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateConversationalAgentThreadRequest
 */
export interface CreateConversationalAgentThreadRequest {
    /**
     * First message sent to the agent
     * @type {string}
     * @memberof CreateConversationalAgentThreadRequest
     */
    prompt: string;
}

/**
 * Check if a given object implements the CreateConversationalAgentThreadRequest interface.
 */
export function instanceOfCreateConversationalAgentThreadRequest(value: object): value is CreateConversationalAgentThreadRequest {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    return true;
}

export function CreateConversationalAgentThreadRequestFromJSON(json: any): CreateConversationalAgentThreadRequest {
    return CreateConversationalAgentThreadRequestFromJSONTyped(json, false);
}

export function CreateConversationalAgentThreadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateConversationalAgentThreadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
    };
}

export function CreateConversationalAgentThreadRequestToJSON(value?: CreateConversationalAgentThreadRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'prompt': value['prompt'],
    };
}

